import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CentralClienteContaListarComponent } from './central-cliente-conta-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: CentralClienteContaListarComponent}
  ])],
  exports: [RouterModule]
})
export class CentralClienteContaListarRoutingModule { }
